import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IConstructionGalleryApiResponse} from "../types/ConstructionGallery";

export const getOfferConstructionGalleryApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getOfferConstructionGallery: build.query<IConstructionGalleryApiResponse, number>({
            query: (offerId) => ({
                url: apiV2Link.offer.pictures(Scenario.OFFER_DETAIL_CONSTRUCTION_GALLERY, {offerId})
            }),
            transformResponse: (response: IConstructionGalleryApiResponse) => ({
                gallery: response.gallery,
                construction_3d_tours: response.construction_3d_tours ?? null
            }),
            // 404 (no construction gallery for this offer) is an expected, benign case - don't notify on it,
            // unlike other statuses which the global rtkq middleware already reports
            transformErrorResponse: (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [404])
        })
    })
});

export const {useGetOfferConstructionGalleryQuery} = getOfferConstructionGalleryApi;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IConstructionGalleryApiResponse} from "../types/ConstructionGallery";

export const getOfferConstructionGalleryApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getOfferConstructionGallery: build.query<IConstructionGalleryApiResponse, number>({
            query: (offerId) => ({
                url: apiV2Link.offer.pictures(Scenario.OFFER_DETAIL_CONSTRUCTION_GALLERY, {offerId})
            }),
            transformResponse: (response: IConstructionGalleryApiResponse) => ({
                gallery: response.gallery,
                construction_3d_tours: response.construction_3d_tours ?? null
            }),
            // 404 (no construction gallery for this offer) is an expected, benign case - don't notify on it,
            // unlike other statuses which the global rtkq middleware already reports
            transformErrorResponse: (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [404])
        })
    })
});

export const {useGetOfferConstructionGalleryQuery} = getOfferConstructionGalleryApi;
